export const authClientParameters = {
    prod: {
        domain: "prod-exciscope.eu.auth0.com",
        client_id: "U8nsNtdQpPFNwraWfHwMlIeFy2bSOLEw",
        clientId: "U8nsNtdQpPFNwraWfHwMlIeFy2bSOLEw",
        useRefreshTokens: true,
        useRefreshTokensFallback: true,
        redirect_uri: window.location.href,
        redirectUri: window.location.href,
        cacheLocation: "localstorage",
        audience: "https://prod-exciscope.eu.auth0.com/api/v2/",
        authorizationParams: {
            redirect_uri: window.location.href,
            audience: 'https://prod-exciscope.eu.auth0.com/api/v2/'
        }
    },
    dev: {
        domain: "dev-exciscope1.eu.auth0.com",
        client_id: "BIlnvMSzLntxlvfUNb6E6FChLkLPFcq7",
        clientId:  "BIlnvMSzLntxlvfUNb6E6FChLkLPFcq7",
        useRefreshTokens: true,
        useRefreshTokensFallback: true,
        redirect_uri: window.location.href,
        redirectUri: window.location.href,
        cacheLocation: 'localstorage',
        audience: 'dev-exciscopeauth0testapi',
        authorizationParams: {
            redirect_uri: window.location.href,
            audience: 'dev-exciscopeauth0testapi'
        }
    }
};